import { gql } from "apollo-angular";

export const RESOURCE_LIBRARY_INFO_FRAGMENT = gql`
  fragment ResourceLibraryInfo on ResourceLibrary {
    library_id
    designation
    created_at
    updated_at
  }
`;